"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/teamSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSection366sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/about/team-img-1.jpg" | "/Templates/Doccure/img/about/team-img-2.jpg" | "/Templates/Doccure/img/about/team-img-3.jpg" | "/Templates/Doccure/img/about/team-img-4.jpg" */
    src: string;
    /** Detected variants: "Alexandra Whitman" | "Victoria Kensington" | "Kennedy Lawson" | "Brooklyn Hayes" */
    link0Text: ReactNode;
    /** Detected variants: "12 Years Experience" | "6 Years Experience" | "8 Years Experience" | "9 Years Experience" */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-3 col-md-6 col-sm-6" */
    className?: string;
    /** Detected variants: "team-item-fifteen wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "team-overley" */
    div0ClassName2?: string;
    /** Detected variants: "team" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "team-content" */
    div1ClassName?: string;
    /** Detected variants: "team-title" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "team-description" */
    p0ClassName?: string;
    socialIconItems?: TeamSectionIconsItem[];
};

type TeamSectionIconsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Facebook" | "Twitter" | "Instagram" | "LinkedIn" */
    ariaLabel: string;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "icon" */
    linkClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeFifteenTeamSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection366sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection366sItem) => Partial<ComponentProps<typeof SmartLink>>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionIconsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "2s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Our Experts" */
    sectionDiv0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Expert Coaching &" */
    sectionDiv0Div0Div0H20H2Text?: ReactNode;
    /** Default: "Facilities" */
    sectionDiv0Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Built for Healing" */
    sectionDiv0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "#" */
    sectionDiv0Div0Link0LinkHref?: string;
    /** Default: "View All Experts" */
    sectionDiv0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "line" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/line-bg.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "about" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-img-two.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    teamSection366s: TeamSection366sItem[];
    teamSection366sItemWrapper?: (item: TeamSection366sItem, content: ReactNode) => ReactNode;
    teamSection366sRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection366sLinkVisible?: boolean;
    teamSection366sLinkRenderer?: (item: TeamSection366sItem, defaultNode: ReactNode) => ReactNode;
    teamSection366sImageVisible?: boolean;
    teamSection366sImageRenderer?: (item: TeamSection366sItem, defaultNode: ReactNode) => ReactNode;
    teamSection366sH3Visible?: boolean;
    teamSection366sH3Renderer?: (item: TeamSection366sItem, defaultNode: ReactNode) => ReactNode;
    teamSection366sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection366sItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSection366sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSection366sH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection366sItem) => Partial<ComponentProps<"h3">>);
    teamSectionIconsItemWrapper?: (item: TeamSectionIconsItem, content: ReactNode) => ReactNode;
    teamSectionIconsRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSectionIconsLinkVisible?: boolean;
    teamSectionIconsLinkRenderer?: (item: TeamSectionIconsItem, defaultNode: ReactNode) => ReactNode;
    teamSectionIconsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionIconsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeFifteenTeamSectionGenerated: FC<HomeFifteenTeamSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0DivText = "Our Experts",
    sectionDiv0Div0Div0H20H2Text = "Expert Coaching &",
    sectionDiv0Div0Div0H20H2Text2 = "Facilities",
    sectionDiv0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0H20H2Props,
    sectionDiv0Div0Div0H20Span0SpanText = "Built for Healing",
    sectionDiv0Div0DivDataWowDuration = "2s",
    sectionDiv0Div0Link0LinkHref = "#",
    sectionDiv0Div0Link0LinkText = "View All Experts",
    sectionDiv0Div0Link0LinkVisible,
    sectionDiv0Div0Link0LinkRenderer,
    sectionDiv0Div0Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "line",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/line-bg.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "about",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/about-img-two.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    linkLinkProps,
    sectionDiv0Div1ClassName,
    teamSection366s,
    teamSection366sItemWrapper,
    teamSection366sRenderer,
    teamSection366sLinkVisible,
    teamSection366sLinkRenderer,
    teamSection366sImageVisible,
    teamSection366sImageRenderer,
    teamSection366sH3Visible,
    teamSection366sH3Renderer,
    teamSection366sLinkProps,
    teamSection366sImageProps,
    teamSection366sH3Props,
    teamSectionIconsItemWrapper,
    teamSectionIconsRenderer,
    teamSectionIconsLinkVisible,
    teamSectionIconsLinkRenderer,
    teamSectionIconsLinkProps,
}) => {
    return (
        <section className="section team-section-fifteen">
            <div className="container">
                <div className="section-header section-header-fifteen wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div>
                        <div className="section-sub-title">{sectionDiv0Div0Div0Div0DivText}</div>
                        {renderNode(sectionDiv0Div0Div0H20H2Visible, sectionDiv0Div0Div0H20H2Renderer, (
                            <h2 className="section-title" {...(sectionDiv0Div0Div0H20H2Props ?? {})}>
                                {sectionDiv0Div0Div0H20H2Text}
                                <br />
                                {sectionDiv0Div0Div0H20H2Text2}
                                {" "}
                                <span>{sectionDiv0Div0Div0H20Span0SpanText}</span>
                            </h2>
                        ))}
                    </div>
                    {renderNode(sectionDiv0Div0Link0LinkVisible, sectionDiv0Div0Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div0Link0LinkHref} className="btn btn-white" {...(sectionDiv0Div0Link0LinkProps ?? {})}>
                            {sectionDiv0Div0Link0LinkText}
                            <span className="icon">
                                <i className="isax isax-arrow-right-1" />
                            </span>
                        </SmartLink>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row row-gap-4"}>
                    {renderCollectionNode(
                        teamSection366s,
                        (item: TeamSection366sItem) => (
                            <div className={item.className ?? "col-lg-3 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "team-item-fifteen wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.div0ClassName2 ?? "team-overley"}>
                                        {renderItemNode(teamSection366sImageVisible, teamSection366sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "team"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof teamSection366sImageProps === "function" ? teamSection366sImageProps(item) : (teamSection366sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "team-content"}>
                                        {renderItemNode(teamSection366sH3Visible, teamSection366sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "team-title"} {...(typeof teamSection366sH3Props === "function" ? teamSection366sH3Props(item) : (teamSection366sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {" "}
                                                {renderItemNode(teamSection366sLinkVisible, teamSection366sLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} {...(typeof teamSection366sLinkProps === "function" ? teamSection366sLinkProps(item) : (teamSection366sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "team-description"}>{item.p0Text}</p>
                                    </div>
                                    <div className="social-icon">
                                        {renderCollectionNode(
                                            item.socialIconItems ?? [],
                                            (item: TeamSectionIconsItem) => (
                                                renderItemNode(teamSectionIconsLinkVisible, teamSectionIconsLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} className={item.linkClassName ?? "icon"} aria-label={item.ariaLabel} {...(typeof teamSectionIconsLinkProps === "function" ? teamSectionIconsLinkProps(item) : (teamSectionIconsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                        <i className={item.className} />
                                                    </SmartLink>
                                                ))
                                            ),
                                            teamSectionIconsItemWrapper,
                                            teamSectionIconsRenderer
                                        )}
                                    </div>
                                </div>
                            </div>
                        ),
                        teamSection366sItemWrapper,
                        teamSection366sRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid line-img" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid element-1" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFifteenTeamSectionGenerated;
